import React, { useEffect, useState } from 'react';
import LayoutModal from '../../../../components/layouts/layout_modal';
import InputDefault from '../../../../components/form/input_default';
import BtnDefault from '../../../../components/buttons/btn_default';
import CustomSpinner from '../../../../components/customs/spinner';
import { postMaterial } from '../../../../services/logistic/material_service';



const MaterialAdd = ({
    accessToken,
    isOpen, setIsOpen,
    setRefresh,
    setAlert,
    setTypeAlert,
    setMessageAlert
}) => {
    const [name, setName] = useState('');
    const [unit, setUnit] = useState('');

    const [errorName, setErrorName] = useState(null);
    const [errorUnit, setErrorUnit] = useState(null);

    const [loading, setLoading] = useState(false)
   

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            setErrorName(null);
            setErrorUnit(null);

            if (name.trim() === '') {
                setErrorName('Nama lengkap wajib diisi..!');
            } else if (name.length < 3) {
                setErrorName('Nama lengkap minimal memiliki 3 huruf..!');
            } else if (unit.length === 0) {
                setErrorName('Unit wajib diisi..!');
            } else {
                const formData = new FormData()
                formData.append('name', name)
                formData.append('unit', unit)

                const response = await postMaterial(accessToken, formData)
                if (response.status === 201) {
                    setIsOpen && setIsOpen(false)
                    setRefresh && setRefresh(true)
                    setAlert && setAlert(true)
                    setTypeAlert && setTypeAlert('success')
                    setMessageAlert && setMessageAlert('Berhasil menyimpan data..!')
                } else if (response.status === 404) {
                    setAlert && setAlert(true)
                    setTypeAlert && setTypeAlert('error')
                    setMessageAlert && setMessageAlert(response.data.message ?? 'gagal menyimpan data..!')
                } else {
                    setAlert && setAlert(true)
                    setTypeAlert && setTypeAlert('error')
                    setMessageAlert && setMessageAlert('gagal menyimpan data..!')
                }

            }
        } catch (error) {
            setAlert && setAlert(true)
            setTypeAlert && setTypeAlert('error')
            setMessageAlert && setMessageAlert('Silahkan periksa koneksi internet Anda..!')
        }
        setLoading(false)
    }

    return (
        <>
            <LayoutModal name={`Tambah Data Barang`} open={isOpen} setOpen={setIsOpen}>
                <form onSubmit={handleSubmit} className='w-full h-full flex py-3 flex-col gap-3 overflow-auto scrollbar-thin scrollbar-track-custom-navy scrollbar-thumb-custom-dark-yellow'>
                    <InputDefault
                        id="name"
                        label="Nama Lengkap"
                        placeholder='Masukkan Nama Lengkap'
                        value={name}
                        setValue={setName}
                        errorMessage={errorName ?? undefined}
                    />

                    <InputDefault
                        id="unit"
                        label="Unit"
                        placeholder='Masukkan Unit'
                        value={unit}
                        setValue={setUnit}
                        errorMessage={errorUnit ?? undefined}
                    />

                    <div className="w-full flex items-center gap-3 justify-evenly">
                        <BtnDefault type="button" handleClick={() => setIsOpen && setIsOpen(false)} addClass='bg-red-500 w-full text-white '>
                            Kembali
                        </BtnDefault>
                        <BtnDefault type="submit" addClass='w-full text-white'>
                            {loading ?
                                <CustomSpinner /> :
                                "Simpan"
                            }
                        </BtnDefault>
                    </div>
                </form>
            </LayoutModal>
        </>
    )
}

export default MaterialAdd